import { render } from "./Advanced.vue?vue&type=template&id=46db1b64&scoped=true&ts=true"
import script from "./Advanced.vue?vue&type=script&lang=ts"
export * from "./Advanced.vue?vue&type=script&lang=ts"

import "./Advanced.vue?vue&type=style&index=0&id=46db1b64&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46db1b64"]])

export default __exports__